import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationStickerMegaphone = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationStickerMegaphone"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        d="M65.4 39.367q.007-.023.008-.042l.216-1.148-4.156-3.733 1.485-1.662-7-6.252-1.466 1.643-.064-.06-1.111-.998-17.147-15.398a11.3 11.3 0 0 0-1.663-1.492l-1.556-.948c-.09-.046-.178-.095-.272-.14a11.3 11.3 0 0 0-4.81-1.05c-3.554 0-7.2 1.545-10.384 4.2l-3.46-6.403-3.658 1.976 4.054 7.507a27 27 0 0 0-2.988 4.423l-8.334-4.816-2.078 3.596 8.715 5.032a26.2 26.2 0 0 0-1.344 5.463l-7.11 3.21 1.711 3.79 5.247-2.369c.393 5.546 2.924 10.197 7.261 12.221q.38.174.767.322l1.863.525c.343.064.691.117 1.042.15l23.287 3.344 1.48.212.06.007-4.808 10.295 11.431 1.964 4.95-10.593 3.293.472.74-.899c.122-.143.235-.29.352-.438l2.097.979.997-1.451a28 28 0 0 0 2.286-4 28 28 0 0 0 1.726-4.783l.435-1.674z"
      />
      <path
        fill="#00D296"
        d="m54.642 31.044 1.473-1.65 3.902 3.486-1.473 1.651M59.292 48.603l2.044.956a26 26 0 0 0 3.713-8.126l-1.972-.922"
      />
      <path
        fill="#00D296"
        d="M34.84 13.254a9.2 9.2 0 0 0-3.044-2.305c-6.357-2.97-14.963 2.013-19.223 11.13-4.26 9.116-2.56 18.915 3.798 21.885.998.466 2.05.736 3.133.825l38.492 5.526a25.3 25.3 0 0 0 3.408-5.422 25.3 25.3 0 0 0 1.957-6.025z"
      />
      <path
        fill="#00D296"
        d="m49.406 60.345-7.19-1.232 4.844-10.366 7.276 1.043z"
      />
      <path fill="#1D2124" d="m12.925 8.557.332-.18 2.839 5.255-.333.18z" />
      <path
        fill="#1D2124"
        fillRule="evenodd"
        d="M18.36 44.817a9 9 0 0 1-2.074-.683c-6.441-3.01-8.187-12.939-3.891-22.138 4.295-9.195 13.033-14.23 19.474-11.22a9.4 9.4 0 0 1 3.049 2.293L54.63 30.776l1.469-1.647 4.182 3.737-1.48 1.657 4.767 4.281-.02.106q-.137.735-.322 1.465l2.038.953-.038.15a26 26 0 0 1-1.61 4.459 26 26 0 0 1-2.13 3.728l-.087.129-2.043-.953a25 25 0 0 1-1.213 1.599l-.068.08-3.629-.522-4.932 10.558-7.57-1.3 4.837-10.358-27.394-3.932a10 10 0 0 1-.998-.143l-.03-.005zm14.323-33.168c-6.058-1.24-13.383 3.609-17.205 11.79-3.821 8.179-2.844 16.9 1.986 20.754a9 9 0 0 1-1.012-.399c-6.256-2.924-7.918-12.629-3.71-21.635 3.389-7.253 9.57-11.877 15.111-11.877 1.338 0 2.645.271 3.861.838q.505.236.969.529m21.372 38.293-6.883-.988-4.68 10.012 6.8 1.167zm3.862.173-3.303-.474.001-.002-7.665-1.1v.002l-3.18-.457c2.58-2.198 4.763-5.115 6.33-8.471 1.554-3.331 2.392-6.849 2.436-10.212l10.62 9.54a25 25 0 0 1-1.922 5.877 25.3 25.3 0 0 1-3.317 5.297M36.033 14.578c2.78 4.517 2.863 11.621-.273 18.336-3.17 6.794-8.763 11.313-14.067 12.001l21.574 3.097c2.65-2.184 4.891-5.14 6.49-8.562 1.583-3.39 2.413-6.98 2.403-10.387zM58.52 34.27l-3.61-3.244 1.22-1.364 3.62 3.234zm3.058 10.71a26 26 0 0 0 1.552-4.233l1.693.789a25.6 25.6 0 0 1-1.545 4.238 26 26 0 0 1-2.01 3.544l-1.694-.793a26 26 0 0 0 2.004-3.544"
        clipRule="evenodd"
      />
      <path
        fill="#1D2124"
        d="m3.781 17.487-.189.327 6.94 4.006.188-.327zM3.77 33.154l3.844-1.74.156.345-3.845 1.739z"
      />
    </svg>
  );
};
export default IllustrationStickerMegaphone;
